export const IMAGES = {
  heroBottle: "/images/celusta-bottle.webp",
  packshot:
    "/images/packshot.webp",
  lifestyle:
    "https://static.prod-images.emergentagent.com/jobs/7440b1ea-23eb-438b-ac5a-41da69872de1/images/ea24dd5263d7f477f52400802265be208f6470e2bf5b757939010d0ef4de8425.jpeg",
  whyLifestyle: "/images/why-lifestyle.webp",
  model:
    "https://images.unsplash.com/photo-1616689321313-4e2eeabd5420?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxibG9uZGUlMjB3b21hbiUyMGhlYWx0aHklMjBoYWlyfGVufDB8fHx8MTc4NjMxMDEyMHww&ixlib=rb-4.1.0&q=85",
};

export const QUICK_BENEFITS = [
  {
    title: "Softer feel",
    text: "Helps dry lengths and ends feel softer.",
    image: "/images/benefit-softer.webp",
  },
  {
    title: "Smoother hair",
    text: "Helps hair feel easier to comb through and manage.",
    image: "/images/benefit-smoother.webp",
  },
  {
    title: "Natural-looking shine",
    text: "Leaves hair looking polished.",
    image: "/images/benefit-shine.webp",
  },
];

export const WHY_CELUSTA = [
  {
    title: "Made for everyday routines",
    text: "Essentials created for daily use — simple to apply and easy to make part of your day.",
  },
  {
    title: "Simple, elevated care",
    text: "A minimal, considered line for hair and body — premium care without the clutter.",
  },
  {
    title: "Thoughtfully selected formulas",
    text: "Every CELUSTA formula is chosen with intention before it earns a place in the line.",
  },
  {
    title: "Designed to fit effortlessly into your routine",
    text: "From hair to body, CELUSTA is built around ease — care that simply fits your life.",
  },
];

export const TRUST_POINTS = [
  { title: "Secure checkout", text: "Secure payment processing" },
  { title: "Premium haircare formula", text: "200 ml leave-in conditioner" },
  { title: "Effortless everyday care", text: "Lightweight leave-in, no rinsing needed" },
  { title: "Customer support", text: "Responsive care team" },
];

export const CARE_POINTS = [
  { title: "Softer feel", text: "Lightweight conditioning helps dry lengths and ends feel softer and more cared for." },
  { title: "Smoother lengths", text: "Designed to help hair feel smoother, easier to comb through and more manageable." },
  { title: "Effortless shine", text: "Helps leave hair looking polished with a healthy-looking finish." },
];

export const STEPS = [
  { num: "1", title: "Spray", text: "Spray onto damp hair, focusing on lengths and ends." },
  { num: "2", title: "Comb through", text: "Comb through gently to distribute the product." },
  { num: "3", title: "Leave in", text: "Do not rinse. Style as usual." },
];

export const FAQS = [
  {
    q: "Which hair types is CELUSTA Leave-In Conditioner suitable for?",
    a: "CELUSTA is designed for a wide range of hair types and is especially suited to hair that could benefit from lightweight conditioning, softness, smoothness and added shine.",
  },
  {
    q: "Do I need to rinse it out?",
    a: "No. CELUSTA is a leave-in conditioner. Spray onto damp hair, comb through and leave it in before styling as usual.",
  },
  {
    q: "How much product do I get?",
    a: "Each bottle contains 200 ml / 6.8 fl oz.",
  },
  {
    q: "How often can I use it?",
    a: "Use as needed as part of your regular hair-care routine. Adjust the amount depending on your hair length, texture and needs.",
  },
  {
    q: "Where can I find the full ingredient list?",
    a: "The complete INCI ingredient list for the CELUSTA Leave-In Conditioner is published in the Ingredients section on this page.",
  },
];
